import { useState, useEffect } from "react";
import classNames from "classnames";

const useUploadProfilePic = ({
  setProfilePic,
  profilePic,
  getProfilePic,
  inputRef,
  clearProfilePic
}) => {
  const [placeHolderOpacity, setPlaceHolderOpacity] = useState(0);

  const handleSetProfilePic = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePic(URL.createObjectURL(file));
      getProfilePic(file);
    }
  };

  const handleRemoveProfilePic = (e) => {
    e.stopPropagation();
    
    setProfilePic(null);
    
    if (inputRef.current) {
      inputRef.current.value = null;
    }
    
    if (typeof getProfilePic === 'function') {
      getProfilePic(null);
    }
  };

  const handleMouseEnter = () => setPlaceHolderOpacity(1);
  const handleMouseLeave = () => setPlaceHolderOpacity(0);

  useEffect(() => {
    if (clearProfilePic && inputRef.current) {
      inputRef.current.value = null;
    }
  }, [clearProfilePic, inputRef]);

  const uploadProfilePicClasses = classNames({
    "upload-placeholder": true,
    "upload-placeholder_hover": profilePic ? false : true,
    "opacity-0": profilePic && placeHolderOpacity === 0 ? true : false,
    "opacity-1": profilePic && placeHolderOpacity === 1 ? true : false,
  });


  return {
    placeHolderOpacity,
    handleSetProfilePic,
    handleRemoveProfilePic,
    handleMouseEnter,
    handleMouseLeave,
    uploadProfilePicClasses,
  };
};

export default useUploadProfilePic;
